export const FILE_FORMAT = "File Format";
export const SpecialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\ ,./~`-=";
export const HEADER_ERR = "Invalid Template";
export const HEADER_ERR_MESSAGE = "The template is invalid. Kindly use the correct template to upload the data.";
export const EXCEL_FORMAT_ERR =
  "File is not in .csv format. Please upload with the given template in .csv";
export const EXCEL_UPLOAD_MAX_ERR_MSG =
  "The maximum file size that can be updated is 25 MB. Please reduce the file size and upload";
export const FILE_SIZE = "File size exceeded";
export const ERROR_IN_DATA = "Errors in data";
export const OUTLET_STATUS_ERR = "Outlet Status Error";
export const OUTLET_STATUS_ERR_MSG_1 = "Outlet status can be only be 0 or 1. You have a wrong outlet status mentioned in row ";
export const OUTLET_STATUS_ERR_MSG_2 = ". Please update the correct status and re-upload";
export const DUPLICATE_DATA = "Duplicate Data";
export const DUPLICATE_DATA_1 =
  "There are duplicate records present in the file with respect to DT Code, Outlet Code in row number ";
export const DUPLICATE_DATA_2 =
  ". Kindly check the file to remove duplicate records and upload again.";
export const INVALID_CHAR =
  "Blank space or Special characters in prefix or suffix";
export const INVALID_CHAR_1 =
  "There are  blank space or special characters in prefix or suffix of values in row number";
export const INVALID_CHAR_2 = ". Please correct the data and reupload the file";
export const EMPTY_VALUE = "Blank/Null Values Mandatory Columns";
export const EMPTY_VALUE_1 = "There are null values present in the row number";
export const EMPTY_VALUE_2 =
  ". We cannot have null values present for an active row. Kindly correct the data and upload again.";
export const CONN_ERR_HEAD = "Connectivity Error";
export const CONN_ERR =
  "File cannot be uploaded due to connectivity issue. Kindly check your internet connection and upload again.";
export const DATA_ERR = 'Data not present in portal';
export const DEVICE_ID_ERR = 'Device ID already mapped';
export const EXCEL_EMPTY_ERR_MSG = "Empty file uploaded, Please upload a valid file.";
export const EXCEL_Template = "Empty file";
export const BAD_REQUEST = "Something went wrong";
export const NO_RESPONSE_ERROR = "File upload failed. The server did not return any details. Please try again";